import angular from 'angular';

let pathToPrivateStaticImages = '';
let pathToPublicStaticImages = '';
const managerHybridLocalhost = 'localhost:4242';
const publicHybridLocalhost = 'localhost:4222';

if (window.location.host === managerHybridLocalhost) {
    // isolated local development
    pathToPrivateStaticImages = '/assets/static-images';
} else {
    // monolithic IIS served, assume our mount path is {host}/Manager
    pathToPrivateStaticImages = '/Manager/client/static-images';
}

if (window.location.host === publicHybridLocalhost) {
    // isolated local development
    pathToPublicStaticImages = '/assets/static-images';
} else {
    // monolithic IIS served, assume our mount path is {host}/Manager
    pathToPublicStaticImages = '/Manager/client/public/static-images';
}

export const ImagePathModule = angular.module('buildium.image-paths', [])
    .constant('STATIC_IMAGES_PATH', pathToPrivateStaticImages)
    .constant('STATIC_IMAGES_PUBLIC_PATH', pathToPublicStaticImages)
    .name;
